import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { FeaturedOrganization } from "../organization.types";

/**
 * Fetch featured organizations for the marketing site network section.
 *
 * Returns organizations marked as featured, with name and location only.
 * Results are cached for 5 minutes since featured organizations don't change often.
 */
export function useFetchFeaturedOrganizations() {
  return useQuery<FeaturedOrganization[]>({
    queryKey: ["organizations", "featured"],
    queryFn: async () => {
      return apiRequest(
        "/organizations/featured/",
        "GET",
        null,
        false
      ) as Promise<FeaturedOrganization[]>;
    },
    staleTime: 5 * 60 * 1000,
  });
}
